module.exports = __webpack_public_path__ + "static/media/FactorySetup_color.f6b9bd86.svg";